const SpecialityTypes = Object.freeze({
    "standard": "standard",
    "button": "button",
    "advisor-profile": "advisor-profile"
});
const SpecialityKinds = Object.freeze({
    "love_readings": "love-readings",
    "psychic_readings": "psychic-readings",
    "tarot_readings": "tarot-readings",
    "astrology_horoscopes": "astrology-horoscopes",
    "palm_readings": "palm-readings",
    "angel_insights": "angel-insights",
    "oracle_guidance": "oracle-guidance",
    "dream_analysis": "dream-analysis",
    "spiritual_medium": "spiritual-medium"
});
var SpecialityProps = { SpecialityTypes, SpecialityKinds };

export { SpecialityProps as default };
//# sourceMappingURL=speciality.js.map
